// extracted by mini-css-extract-plugin
module.exports = {"root":"RootLayout_root__d28iX","app":"RootLayout_app__4eVaG"};